import { Link, useNavigate, useParams, useSearch } from '@tanstack/react-router';
import { PeriodPicker } from '../PeriodPicker.tsx';
import { lastDays, type Period } from '../period.ts';
import { PushPerformancePanel } from './PushPerformancePanel.tsx';

/**
 * Analytics → Push (BB-79): per-delivery push performance of the whole environment by platform, day or variant, with
 * the send-cohort / event-day switch, and why pushes were not sent. The period lives in the URL, so a view can be shared.
 */
export function PushAnalyticsPage() {
  const { environmentId } = useParams({ from: '/env/$environmentId/analytics/push' });
  const search = useSearch({ from: '/env/$environmentId/analytics/push' });
  const navigate = useNavigate({ from: '/env/$environmentId/analytics/push' });
  const period: Period = search.from && search.to ? { from: search.from, to: search.to } : lastDays(30);
  const setPeriod = (p: Period) => void navigate({ search: { from: p.from, to: p.to }, replace: true });
  return (
    <section>
      <h1>Push analytics</h1>
      <p className="hint">
        Every push counted once per device it was sent to, as in Braze Message Performance. The channel dashboard counts users instead:{' '}
        <Link to="/env/$environmentId/dashboards/$channel" params={{ environmentId, channel: 'push' }}>
          Push channel dashboard
        </Link>
        .
      </p>
      <PeriodPicker value={period} onChange={setPeriod} />
      <PushPerformancePanel environmentId={environmentId} period={period} allowBasis />
    </section>
  );
}
